export default "__VITE_PUBLIC_ASSET__4a0f1379__"